// Utilitarios das telas de Prospeccao (captacao de RJ e TCA).
import { registerBadgeSet } from "@/components/ui/badge-statuses";

export { errorMessage, formatDate, formatDateTime, notifyError, notifySuccess, openUrl } from "@/components/rma/rma.util";

// <ui-badge set="prospect-import" :status="item.status">
registerBadgeSet("prospect-import", {
  preview: ["Em prévia", "warning"],
  confirmed: ["Confirmada", "success"],
  cancelled: ["Cancelada", "neutral"],
});

// Resultado da linha contra a base de casos.
registerBadgeSet("prospect-operation", {
  new: ["Novo", "info"],
  update: ["Atualiza", "purple"],
  unchanged: ["Sem mudança", "neutral"],
  conflict: ["Conflito", "warning"],
});

registerBadgeSet("prospect-type", {
  rj: ["RJ", "info"],
  tca: ["TCA", "purple"],
  rext: ["R. Extra", "teal"],
});

export const SUGGESTION_TABS = [
  { value: "relevant", text: "Relevantes", tone: "success" },
  { value: "review", text: "Revisar", tone: "warning" },
  { value: "discard", text: "Descartadas", tone: "neutral" },
  { value: "all", text: "Todas" },
];

export const TYPE_ITEMS = [
  { value: "rj", text: "RJ" },
  { value: "tca", text: "TCA" },
  { value: "rext", text: "R. Extra" },
];

export const FIELD_LABELS = {
  type: "tipo",
  company_name: "empresa",
  company_document: "CNPJ",
  authors: "autores",
  defendants: "réus",
  authors_lawyers: "advogados dos autores",
  defendants_lawyers: "advogados dos réus",
  claim_amount: "valor da causa",
  tribunal: "tribunal",
  system: "sistema",
  comarca: "comarca",
  city: "cidade",
  uf: "UF",
  court_name: "vara",
  judge_name: "juiz",
  process_class: "classe",
  subject: "assunto",
  filed_at: "distribuição",
  summary_ai: "resumo",
  files_url: "link da íntegra",
  files_url_expires_at: "validade do link",
};

const money = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });

export function formatMoney(value) {
  if (value === null || value === undefined || value === "") return "—";
  return money.format(Number(value));
}

// Valores grandes em mi/bi, como no material da sexta.
export function formatMoneyShort(value) {
  if (value === null || value === undefined || value === "") return "—";
  const number = Number(value);
  if (number >= 1e9) return `R$ ${(number / 1e9).toLocaleString("pt-BR", { maximumFractionDigits: 1 })} bi`;
  if (number >= 1e6) return `R$ ${(number / 1e6).toLocaleString("pt-BR", { maximumFractionDigits: 1 })} mi`;
  return formatMoney(number);
}

export function formatDocument(value) {
  const digits = String(value || "").replace(/\D/g, "");
  if (digits.length === 14) return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
  if (digits.length === 11) return digits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
  return value || "";
}

// As datas do feed vem no horario de Brasilia, sem fuso: so reformata.
export function formatFeedDate(value) {
  if (!value) return "—";
  const text = String(value);
  return `${text.slice(8, 10)}/${text.slice(5, 7)}/${text.slice(0, 4)}`;
}

// Etapa do pipeline de prospeccao.
registerBadgeSet("prospect-pipeline", {
  captado: ["A triar", "warning"],
  acompanhar: ["Acompanhar", "info"],
  onepage: ["Onepage", "primary"],
  agenda_marcada: ["Agenda marcada", "purple"],
  aguardando_decisao: ["Aguardando decisão", "teal"],
  nomeada_bej: ["Nomeada BeJ", "success"],
  nomeado_concorrente: ["Nomeado concorrente", "danger"],
  passivo_baixo: ["Passivo baixo", "neutral"],
  nao_atuar: ["Não atuar", "neutral"],
  descartado: ["Descartado", "neutral"],
  encerrado_sem_rj: ["Encerrado sem RJ", "neutral"],
});

export const PIPELINE_LABELS = {
  captado: "A triar",
  acompanhar: "Acompanhar",
  onepage: "Onepage",
  agenda_marcada: "Agenda marcada",
  aguardando_decisao: "Aguardando decisão",
  nomeada_bej: "Nomeada BeJ",
  nomeado_concorrente: "Nomeado concorrente",
  passivo_baixo: "Passivo baixo",
  nao_atuar: "Optamos por não atuar",
  descartado: "Descartado",
  encerrado_sem_rj: "Encerrado sem RJ",
};

// Etapas que a equipe move na ficha (nomeacoes vem do lancamento da AJ).
export const MANUAL_STATUS_ITEMS = ["captado", "acompanhar", "onepage", "agenda_marcada", "aguardando_decisao", "passivo_baixo", "nao_atuar", "descartado", "encerrado_sem_rj"]
  .map((value) => ({ value, text: PIPELINE_LABELS[value] }));

export const PENDING_STATUS_ITEMS = ["acompanhar", "onepage", "agenda_marcada", "aguardando_decisao", "passivo_baixo", "nao_atuar"]
  .map((value) => ({ value, text: PIPELINE_LABELS[value] }));

export const SECTOR_ITEMS = [
  { value: "industria", text: "Indústria" },
  { value: "agro", text: "Agro" },
  { value: "varejo", text: "Varejo" },
  { value: "construcao", text: "Construção" },
  { value: "transporte", text: "Transporte" },
  { value: "servicos", text: "Serviços" },
  { value: "saude", text: "Saúde" },
  { value: "energia", text: "Energia" },
  { value: "outro", text: "Outro" },
];

export const ACTIVITY_TYPE_ITEMS = [
  { value: "bej_move", text: "Movimento BeJ (onepage, e-mail, ligação)" },
  { value: "meeting", text: "Agenda realizada" },
  { value: "court_feedback", text: "Feedback do juízo" },
  { value: "court_move", text: "Movimento dos autos" },
  { value: "internal_decision", text: "Decisão interna" },
];

export const ACTIVITY_TONES = {
  bej_move: "primary",
  meeting: "purple",
  court_feedback: "teal",
  court_move: "info",
  internal_decision: "neutral",
  procedural_check: "info",
  system: "neutral",
};

export const APPOINTMENT_LABELS = { pending: "Pendente", appointed: "Nomeado", not_applicable: "N/A" };

// Hoje no horario de Brasilia (YYYY-MM-DD), para datas padrao dos formularios.
export function todayKey() {
  return new Intl.DateTimeFormat("sv-SE", { timeZone: "America/Sao_Paulo" }).format(new Date());
}

// Dias desde uma data (carimbo do banco em UTC ou data de calendario).
export function daysSince(value) {
  if (!value) return null;
  const text = String(value);
  const date = /^\d{4}-\d{2}-\d{2}$/.test(text) ? new Date(`${text}T12:00:00Z`) : new Date(/^\d{4}-\d{2}-\d{2} /.test(text) ? `${text.replace(" ", "T")}Z` : text);
  if (Number.isNaN(date.getTime())) return null;
  return Math.max(0, Math.floor((Date.now() - date.getTime()) / 86400000));
}

export const MEETING_MODE_ITEMS = [
  { value: "presencial", text: "Presencial" },
  { value: "virtual", text: "Virtual" },
  { value: "email", text: "E-mail" },
];

export const ONEPAGE_ITEMS = [
  { value: "none", text: "Sem onepage" },
  { value: "drafting", text: "Em redação" },
  { value: "review", text: "Em revisão" },
  { value: "ok", text: "Pronto" },
  { value: "sent", text: "Enviado" },
];

export const MEETING_RESULT_ITEMS = [
  { value: "aguarda_decisao", text: "Aguarda decisão" },
  { value: "receptivo", text: "Receptivo" },
  { value: "pp_bej", text: "BeJ nomeada para PP" },
  { value: "aj_bej", text: "BeJ nomeada AJ" },
  { value: "outro_nomeado", text: "Outro AJ nomeado" },
  { value: "sem_retorno", text: "Sem retorno" },
];

registerBadgeSet("prospect-meeting", {
  scheduled: ["Marcada", "info"],
  done: ["Realizada", "success"],
  cancelled: ["Cancelada", "neutral"],
});

// Abre um PDF gerado pela API (autenticado) numa aba nova.
export async function openPdf(axios, url, params = {}) {
  const result = await axios.get(url, { params, responseType: "blob" });
  const blobUrl = window.URL.createObjectURL(new Blob([result.data], { type: "application/pdf" }));
  window.open(blobUrl, "_blank", "noopener");
  setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
}

export function formatShortDate(value) {
  const text = String(value || "");
  return text ? `${text.slice(8, 10)}/${text.slice(5, 7)}` : "";
}

// Roteiros de visita (etapa 5b).
registerBadgeSet("prospect-trip", {
  rascunho: ["Rascunho", "neutral"],
  planejado: ["Planejado", "info"],
  em_andamento: ["Em andamento", "warning"],
  concluido: ["Concluído", "success"],
  cancelado: ["Cancelado", "neutral"],
});

export const TRIP_STATUS_ITEMS = [
  { value: "rascunho", text: "Rascunho" },
  { value: "planejado", text: "Planejado" },
  { value: "em_andamento", text: "Em andamento" },
  { value: "concluido", text: "Concluído" },
  { value: "cancelado", text: "Cancelado" },
];

export const UF_ITEMS = ["AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO"];

// "3h20" / "45 min"
export function formatHours(minutes) {
  const total = Math.round(Number(minutes) || 0);
  const hours = Math.floor(total / 60);
  const rest = total % 60;
  return hours ? `${hours}h${String(rest).padStart(2, "0")}` : `${rest} min`;
}
